import React, { Component } from 'react';
import { colors } from '../styles'

import {
    TitleText,
    BigText,
    SmallText,
    ListContainer,
    ListItem,
    PrimaryButton,
    ButtonText,
    MenuContainer,
    ResponseContainer,
} from './StyledComponents'

const TIPOS_PAGAMENTO = [
    { valor: 'P', texto: 'PIX' },
    { valor: 'D', texto: 'Depósito' },
]

/**
 * Distribuidor na solicitacao de deposito V2: antes da foto, escolhe a qual
 * solicitacao o comprovante pertence e se o pagamento foi PIX ou deposito.
 */
export default class EscolhaSolicitacao extends Component {
    constructor(props) {
        super(props)
        this.state = {
            solicitacao: undefined,
            tipoPagamento: undefined,
        }
    }

    formataValor(valor) {
        if (valor === null || valor === undefined)
            return ''

        return 'R$ ' + Number(valor).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }

    handleContinuar = () => {
        const { solicitacao, tipoPagamento } = this.state

        if (solicitacao && tipoPagamento)
            this.props.onConfirmar(solicitacao, tipoPagamento)
    }

    renderSolicitacao = (sol) => {
        // iddepositodiarios: os depositos lancados na 2650 ainda nao tem idrequisicao
        const selecionada = this.state.solicitacao && this.state.solicitacao.iddepositodiarios === sol.iddepositodiarios
        const reprovada = sol.idstatus === 4
        const lancado = sol.origem === 'LANCADO'

        return (
            <ListItem key={sol.iddepositodiarios}
                style={selecionada ? styles.itemSelecionado : styles.item}
                onClick={() => this.setState({ solicitacao: sol })}>
                <span style={styles.valor}>{this.formataValor(sol.valor)}</span>
                <span style={styles.data}> {sol.data}</span>
                <br />
                <span style={styles.detalhe}>{[sol.banco, sol.beneficiario].filter(Boolean).join(' · ')}</span>
                {reprovada && <span style={styles.reprovada}> Reprovado – reenviar</span>}
                {lancado && <span style={styles.lancado}> Lançado pelo financeiro</span>}
            </ListItem>
        )
    }

    renderTipoPagamento = (tipo) => {
        const selecionado = this.state.tipoPagamento === tipo.valor

        return (
            <PrimaryButton key={tipo.valor}
                inverter={!selecionado}
                style={styles.botaoTipo}
                onClick={() => this.setState({ tipoPagamento: tipo.valor })}>
                <ButtonText claro={selecionado} rosa={!selecionado}>{tipo.texto}</ButtonText>
            </PrimaryButton>
        )
    }

    render() {
        const { solicitacoes, nomeDistribuidor, onVoltar } = this.props
        const { solicitacao, tipoPagamento } = this.state

        if (!solicitacoes || solicitacoes.length === 0) {
            return (
                <ResponseContainer>
                    <BigText>Não há solicitação de depósito aguardando comprovante para {nomeDistribuidor}.</BigText>
                    <SmallText>Solicite ou lance o depósito (Gerenciador Filial ou Gerenciador Financeiro) e depois envie a foto do comprovante.</SmallText>
                    <PrimaryButton centered onClick={onVoltar}>
                        <ButtonText claro>voltar</ButtonText>
                    </PrimaryButton>
                </ResponseContainer>
            )
        }

        return (
            <div style={styles.container}>
                <TitleText>Qual solicitação é este comprovante?</TitleText>
                <SmallText>{nomeDistribuidor}</SmallText>

                <ListContainer style={styles.lista}>
                    {solicitacoes.map(this.renderSolicitacao)}
                </ListContainer>

                <BigText style={styles.pergunta}>O pagamento foi feito por</BigText>
                <MenuContainer>
                    {TIPOS_PAGAMENTO.map(this.renderTipoPagamento)}
                </MenuContainer>

                <MenuContainer>
                    <PrimaryButton inverter onClick={onVoltar}>
                        <ButtonText rosa>Voltar</ButtonText>
                    </PrimaryButton>
                    <PrimaryButton
                        disabled={!solicitacao || !tipoPagamento}
                        style={!solicitacao || !tipoPagamento ? styles.desabilitado : undefined}
                        onClick={this.handleContinuar}>
                        <ButtonText claro>Continuar</ButtonText>
                    </PrimaryButton>
                </MenuContainer>
            </div>
        );
    }
}

const styles = {
    container: {
        width: '100%',
        paddingTop: 30,
        paddingBottom: 20,
    },
    lista: {
        maxHeight: '45vh',
        height: 'auto',
        marginTop: 16,
    },
    item: {
        display: 'block',
        cursor: 'pointer',
    },
    itemSelecionado: {
        display: 'block',
        cursor: 'pointer',
        backgroundColor: colors.rosaMaisClaro,
        borderLeft: 'solid 4px ' + colors.rosaForte,
    },
    valor: {
        fontWeight: 700,
        color: colors.pretoPreto,
    },
    data: {
        fontSize: '0.8em',
    },
    detalhe: {
        fontSize: '0.75em',
    },
    reprovada: {
        fontSize: '0.75em',
        fontWeight: 700,
        color: colors.danger,
    },
    lancado: {
        fontSize: '0.75em',
        fontWeight: 700,
        color: colors.rosaForte,
    },
    pergunta: {
        marginTop: 20,
    },
    botaoTipo: {
        marginTop: 10,
    },
    desabilitado: {
        opacity: 0.4,
    },
}
